<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Update Security Deposit</p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="4">
            <p class="caption">Tenant:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="8">
            <p class="caption font-weight-bold">
              {{ securityDeposit.tenantName }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="4">
            <p class="caption">Unit:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="8">
            <p class="caption font-weight-bold">
              {{ securityDeposit.unitName }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="4">
            <p class="caption">Amount:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="8">
            <p class="caption font-weight-bold">
              {{ formatCurrency(securityDeposit.amount) }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="4">
            <p class="caption">Refunded Amount:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="8">
            <p class="caption font-weight-bold">
              {{ refundedAmount }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="4">
            <p class="caption">Usable Amount:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="8">
            <p class="caption font-weight-bold">
              {{ usableAmount }}
            </p>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <p
          v-if="filteredConsumePayments && filteredConsumePayments.length"
          class="caption font-weight-bold"
        >
          Consumed payments
        </p>
        <v-list-item
          v-for="(paidPayment, index) in filteredConsumePayments"
          :key="paidPayment._id"
          two-line
        >
          <v-list-item-avatar color="grey lighten-1">
            <p class="caption white--text">
              P_{{ securityDeposit.consumePayment_details[index].refNo }}
            </p>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="body-2">
              Total amount:
              {{ formatCurrency(paidPayment.amount) }}</v-list-item-title
            >
            <v-list-item-subtitle class="caption">
              status: {{ paidPayment.status }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <p
          v-if="securityDeposit.rejectRefundReason"
          class="caption font-weight-bold"
        >
          Reason for rejection
        </p>
        <p style="white-space: pre">{{ securityDeposit.rejectRefundReason }}</p>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="font-weight-bold"
          color="grey darken-1"
          text
          @click="close"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatCurrency } from '../../util/currency'
import { getUsableAmount } from '../../util/securityDeposit'
import { SecurityDepositConsumeStatus } from '../../config/securityDeposit'

export default {
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      securityDeposit: {},
      filteredConsumePayments: [],
      formatCurrency
    }
  },
  computed: {
    usableAmount() {
      return formatCurrency(getUsableAmount(this.securityDeposit))
    },
    refundedAmount() {
      return formatCurrency(this.securityDeposit.refundedAmount || 0)
    }
  },
  methods: {
    open(item) {
      this.securityDeposit = item
      this.dialog = true

      const consumePayments = this.securityDeposit.consumePayments || []

      this.filteredConsumePayments = consumePayments.filter(
        (cp) => cp.status !== SecurityDepositConsumeStatus.FAILED
      )
    },
    close() {
      this.dialog = false
    }
  }
}
</script>
